import React from 'react';
import { Alert } from 'react-bootstrap';
import { Outlet } from 'react-router-dom';
//import { useTranslation } from 'react-i18next';
import FeatureFlag from '../featureFlag/FeatureFlag';
//import { useGetAllUserResourcesQuery } from './userSlice'

const Dashboard = () => {
  //const { t:_ } = useTranslation();
  //const { data, isLoading, isSuccess, error } = useGetAllUserResourcesQuery();

  return (
    <FeatureFlag
      flag={['dashboard', 'dev']}
      fallback={
        <Alert variant="warning">User dashboard route isn't ready yet.</Alert>
      }
    >
      <Outlet />
    </FeatureFlag>
  );
};

export default Dashboard;
